module.exports = [{
      plugin: require('/Users/ruucm/MyDocuments/Carving/projects/harborschool-gatsby/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
